module.exports = __webpack_public_path__ + "static/wordpress2-ece5eae5d9336f9cc0e96912b54cbad2.png";